import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import Mails from '@iso/redux/mail/reducer';
import Users from '@iso/redux/users/reducer';
import DynamicChartComponent from '@iso/redux/dynamicEchart/reducer';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';
import Invoices from '@iso/redux/invoice/reducer';
import drawer from '@iso/redux/drawer/reducer';
import modal from '@iso/redux/modal/reducer';
import profile from '@iso/redux/profile/reducer';
import Denuncias from '@iso/redux/denuncias/reducers';
import Empresas from '@iso/redux/empresas/reducer';
import Productos from '@iso/redux/productos/reducer';
import Ventas from '@iso/redux/ventas/reducer';
import Inventario from '@iso/redux/inventario/reducer';
import Ops from '@iso/redux/ops/reducer';
import UsersRRHH from '@iso/redux/RRHH/reducer';
import Caja from '@iso/redux/caja/reducer';
import Proveedores from '@iso/redux/proveedores/reducer';
import Cotizaciones from '@iso/redux/cotizaciones/reducer';
import Compras from '@iso/redux/compras/reducer';
import NotasCierre from '@iso/redux/notasCierre/reducer';
import Downloads from '@iso/redux/downloads/reducer';
import PedidosOnline from '@iso/redux/pedidosOnline/reducer';
import Siigo from '@iso/redux/Siigo/reducer';
import Contabilidad from '@iso/redux/contabilidad/reducer';

export default combineReducers({
  Auth,
  App,
  Users,
  Invoices,
  Ops,
  modal,
  drawer,
  profile,
  Denuncias,
  Empresas,
  Productos, 
  Ventas,
  ThemeSwitcher,
  Mails,
  DynamicChartComponent,
  Inventario,
  UsersRRHH,
  Caja,
  Proveedores,
  Cotizaciones,
  Compras,
  NotasCierre,
  Downloads,
  PedidosOnline,
  Siigo,
  Contabilidad
});
